import { RewardLogsQueryParams } from '@adminServices';
import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CreateRewardLogDto } from '@klubovna/api-client';
import { Store } from '@ngrx/store';
import * as RewardLogsActions from './reward-logs.actions';
import * as RewardLogsSelectors from './reward-logs.selectors';

@Injectable({
  providedIn: 'root',
})
export class RewardLogsFacade {
  private store = inject(Store);

  rewardLogs$ = this.store.select(RewardLogsSelectors.selectAllRewardLogs);
  loading$ = this.store.select(RewardLogsSelectors.selectRewardLogsLoading);
  error$ = this.store.select(RewardLogsSelectors.selectRewardLogsError);
  pagination$ = this.store.select(RewardLogsSelectors.selectRewardLogsPagination);

  rewardLogs = toSignal(this.rewardLogs$, { initialValue: [] });
  loading = toSignal(this.loading$, { initialValue: false });

  loadRewardLogs(params?: RewardLogsQueryParams): void {
    this.store.dispatch(RewardLogsActions.loadRewardLogs({ params }));
  }

  createRewardLog(rewardLogData: CreateRewardLogDto): void {
    this.store.dispatch(RewardLogsActions.createRewardLog({ rewardLogData }));
  }

  deleteRewardLog(id: string): void {
    this.store.dispatch(RewardLogsActions.deleteRewardLog({ id }));
  }
}

